import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import swal from 'sweetalert';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  config: any = {}

  constructor(
    private configService: ConfigService,
    private titleService: Title
  ) {
    this.getConfig()
  }

  ngOnInit(): void {
  }

  getConfig() {
    this.configService.config().subscribe(
      data => {
        this.config = data
        this.titleService.setTitle('Home | ' + data.nome)
      }, err => {
        swal("erro", "não foi possível conectar", "error")
      }
    )
  }

}
